<template>
  <div class="core-column">
    <TheContent
      v-for="item of elem.children"
      :key="item.id"
      :elem="{ ...item, isColumn: true }"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '../../TheContent';

  export default defineNuxtComponent({
    name: 'CoreColumn',

    components: {
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<TContent>,
        required: true,
      },
    },
  });
</script>

<style lang="scss" scoped>
  .core-column {
    display: flex;
    margin: auto;
    overflow: hidden;
    flex-basis: 100%;
    justify-content: center;

    @include mobile {
      flex-basis: 50%;
    }
  }
</style>
